/**
 * Fiscal Printer - encoding and text utilities
 */
import { WIN1250_MAP, DIACRITICS_ASCII_MAP } from './constants';

/**
 * Convert text to Windows-1250 byte array (Polish encoding)
 */
export function textToBytes(text) {
  const bytes = [];
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (WIN1250_MAP[char]) {
      bytes.push(WIN1250_MAP[char]);
    } else {
      bytes.push(char.charCodeAt(0) & 0xFF);
    }
  }
  return bytes;
}

/**
 * Escape special XML characters
 */
export function escapeXml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/**
 * Strip Polish diacritics → ASCII (e.g. for cashier name)
 */
export function stripDiacritics(text) {
  return text.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, c => DIACRITICS_ASCII_MAP[c] || c);
}

/**
 * Calculate Novitus checksum: XOR of all data bytes starting at 0xFF,
 * returned as two ASCII hex characters.
 */
export function calculateChecksum(data) {
  let checksum = 0xFF;
  for (let i = 0; i < data.length; i++) {
    checksum ^= data[i];
  }
  const hexString = checksum.toString(16).toUpperCase().padStart(2, '0');
  return [hexString.charCodeAt(0), hexString.charCodeAt(1)];
}
